import { Injectable, Injector } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { SetorModel } from '../models';


@Injectable({
  providedIn: 'root'
})
export class SetorService extends BaseCrudService<SetorModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'setor';
  }

  get(): Observable<SetorModel[]> {
    return this
      .httpClient
      .get<SetorModel>(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
